import { post, getJson,put ,deleteMethod} from '@/api/http';

/** 新增第三方推流 */

export const addPushstream = (data,token) => post(`${config.cpp}monitor/v1/webcast/pushstream`,data,{token})

/** 获取第三方推流列表 */
export const getPushstreamList = (params,token) => getJson(`${config.cpp}monitor/v1/webcast/pushstream/${params.webcastId}`,null,{token});

/** 删除第三方推流 */


export const deletPushstream = (id,token) => deleteMethod(`${config.cpp}monitor/v1/webcast/pushstream/${id}`,{token})

/** 自定义推流开始推流 */
export const startPushstream = (data,token) =>  post(`${config.cpp}monitor/v2/webcast/pushstream/${data.id}/start`,data,{token});



/** 自定义推流停止推流 */
export const stopPushstream = (data,token) => post( `${config.cpp}monitor/v1/webcast/pushstream/${data.id}/stop`,data,{token});


/** 一键推流 */
export const startAllPushstream = (token) =>post( `${config.cpp}monitor/v2/webcast/pushstream/start`,null,{token});

export const editPushstream = (data,token)=>put(`${config.cpp}monitor/v1/webcast/pushstream/${data.id}`,data,{token})